<template>
    <div>
        <div class="autocomplete custom-auto-complete">
            <div class="autocomplete__box">
                <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxnPgogICAgPHBhdGggc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZmlsbD0ibm9uZSIgZD0iTTExIDExbDMuNSAzLjUiPjwvcGF0aD4KICAgIDxjaXJjbGUgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjIiIGN4PSI2LjUiIGN5PSI2LjUiIHI9IjUuNSIgZmlsbD0ibm9uZSI+PC9jaXJjbGU+CiAgPC9nPgo8L3N2Zz4K" class="autocomplete__icon">
                <div class="autocomplete__inputs">
                    <input placeholder="Busca por relatórios" type="text" autocomplete="off" v-model="search" @keyup="filterMenus">
                </div>
            </div>
        </div>
        <autocomplete style="display: none" source=""></autocomplete>

        <div class="toogle-itens">

            <div class="toogle-header" :class="showCollapse ? 'collapsed' : null"
                 :aria-expanded="showCollapse ? 'true' : 'false'" aria-controls="collapse-favoritos"
                 @click="showCollapse = !showCollapse">

                <span>FAVORITOS</span>
            </div>

            <div v-for="favorito in favoritos">
                <b-collapse id="collapse-favoritos" v-model="showCollapse" class="mt-2">
                    <b-card>
                        <div class="box-categoria">
                             <router-link :to="'/analytics/'+ favorito.relatorio.slug">
                               <i :class="'icon ' + favorito.relatorio.icon"></i>
                                <span>{{favorito.relatorio.nome}}</span>
                             </router-link>
                        </div>
                        <div class="arrows">
                            <span class="arrow-up" @click="setOrdem(favorito.relatorio.id, 'down')"></span>
                            <span class="arrow-down" @click="setOrdem(favorito.relatorio.id, 'up')"></span>
                        </div>
                    </b-card>
                </b-collapse>
            </div>

            <div class="toogle-header" :class="showCollapseRelatorios ? 'collapsed' : null"
                 :aria-expanded="showCollapseRelatorios ? 'true' : 'false'" aria-controls="collapse-relatorios"
                 @click="showCollapseRelatorios = !showCollapseRelatorios">
                <span>RELATÓRIOS</span>
            </div>

            <div v-for="menu in menusVisiveis">

                <b-collapse id="collapse-relatorios" v-model="showCollapseRelatorios" class="posicao-vendas">
                    <b-card>
                        <div class="box-categoria">
                            <router-link :to="'/analytics/'+ menu.slug">
                                <i :class="'icon ' + menu.icon"></i>
                                <span>{{menu.nome}}</span>
                            </router-link>
                        </div>
                        <div class="arrows">
                            <span :class="menu.favoritado ? 'icon-star' : 'icon-star-empty'"
                                  @click="e => callFunction(menu.id, menu.favoritado, e)">
                            </span>
                        </div>
                    </b-card>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
    import BootstrapVue from 'bootstrap-vue';
    import Autocomplete from 'vuejs-auto-complete';

    export default {
        components: {
            BootstrapVue, Autocomplete
        },
        data() {
            return {
                favoritos: [],
                menus: [],
                menusVisiveis: [],
                showCollapse: true,
                showCollapseRelatorios: true,
                search: null
            }
        },
        methods: {
            getMenus()
            {
                this.axios.get(_ROOT_PATH_ANALYTICS + '/api/menu/todos').then((result) => {
                    this.menus         = result.data;
                    this.menusVisiveis = result.data;
                });
            },
            getFavoritos()
            {
                this.axios.get(_ROOT_PATH_ANALYTICS + '/api/menu/favoritos').then((result) => {
                    this.favoritos = result.data;
                });
            },
            setOrdem(relatorio, direcao)
            {
                this.axios.post(_ROOT_PATH_ANALYTICS + '/api/menu/favoritos/ordem', {relatorioId: relatorio, direcao: direcao}).then((result) => {
                    if (result.data.status === 'OK')
                    {
                        this.getFavoritos();
                    }
                });
            },
            callFunction(relatorio, favoritado, event)
            {
                if (favoritado)
                {
                    this.deleteFavorito(relatorio, event);
                }
                else
                {
                    this.setFavorito(relatorio, event);
                }
            },
            setFavorito(relatorio, event)
            {
                this.axios.post(_ROOT_PATH_ANALYTICS + '/api/menu/favoritar', {relatorioId: relatorio}).then((result) => {
                    if (result.data.status === 'OK')
                    {
                        event.target.classList.toggle('icon-star');
                        this.getMenus();
                        this.getFavoritos();
                    }
                });
            },
            deleteFavorito(relatorio)
            {
                this.axios.delete(_ROOT_PATH_ANALYTICS + '/api/menu/desfavoritar', {params: {relatorioId: relatorio}}).then((result) => {
                    if (result.data.status === 'OK')
                    {
                        this.getMenus();
                        this.getFavoritos();
                    }
                });
            },
            filterMenus: _.debounce(function ()
            {
                if (!this.search)
                {
                    this.menusVisiveis = this.menus;
                }

                this.menusVisiveis = this.menus.filter(c => c.nome.toLowerCase().indexOf(this.search) > -1);
            }, 800),
        },
        mounted() {
            this.getMenus();
            this.getFavoritos();
        }
    }
</script>

<style lang="scss">
    .posicao-vendas {
        .arrows {
            span {
                right: 1px;
            }
        }
    }

    .box-categoria {
        display: flex;
        align-items: center;
        a{
            color: #fff;
            text-decoration: none;
        }
        a:hover, .menu-active{
            color: #252642;
        }

        i {
            margin-right: 10px;
        }
    }

    .arrows {
        position: relative;
        right: 0;
        float: right;
        width: 100%;
        max-width: 14px;
        top: -20px;

        span {
            position: absolute;
            cursor: pointer;
        }

        .arrow-down {
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 6px solid #fff;
        }

        .arrow-up {
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #fff;
            top: 15px;
        }

    }

    .toogle-itens {
        padding: 20px;
        padding-top: 0;
    }

    .toogle-header {
        color: #252642;
        text-transform: uppercase;
        cursor: pointer;
        position: relative;
        margin: 20px 0 30px;

        &::after {
            content: '-';
            color: #02a6e3;
            background: #136a98;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            position: absolute;
            right: 0;
            top: -3px;
            font-size: 15px;
            padding-left: 8px;
            padding-top: 1px;
        }

        &::before {
            content: "";
            position: absolute;
            width: 100%;
            max-width: 155px;
            background: #0a1a3f;
            height: 1px;
            left: 92px;
            top: 6px;
        }
    }

    .collapsed {
        &::after {
            content: '+';
            padding-top: 2px;
            padding-left: 6px;
        }
    }

    .card {
        background: transparent;
        border: 0 solid rgba(0, 0, 0, 0.125);
        position: relative;
        border-bottom: 1px solid #4dc7f4;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }

    .card-body {
        padding: 0;
        color: #fff;
    }

    .card:last-child {
        border-color: transparent;
    }

    .custom-auto-complete {
        .autocomplete__box {
            border: 1px solid #fff;
            border-radius: 0;
        }
        .autocomplete__inputs {
            padding: 15px;
            input {
                font-size: 14px;
            }
        }
        .autocomplete__results {
            font-size: 14px;
        }
    }
</style>
